module.exports = __webpack_public_path__ + "static/media/Telangana.1e54d911.PNG";